import { LatLngLiteral } from '@googlemaps/google-maps-services-js';
import { createFeature, createReducer, on } from '@ngrx/store';
import { ClientServiceCreateResponseJson } from '@vmspdb/definitions';
import { PaginatedClientActions } from './paginated-client.actions';

export const paginatedClientFeatureKey = 'paginatedClient';

export interface PaginatedClientState {
  items: ClientServiceCreateResponseJson[];
  loading: boolean;
  total: number;
  page: number;
  error: any;
  refGeoPoint: LatLngLiteral | undefined;
}

export const initialState: PaginatedClientState = {
  items: [],
  total: 0,
  page: 0,
  loading: false,
  error: undefined,
  refGeoPoint: undefined,
};

export const reducer = createReducer(
  initialState,
  on(
    PaginatedClientActions.listPaginatedClients,
    (state): PaginatedClientState => ({ ...state, loading: true }),
  ),
  on(
    PaginatedClientActions.listPaginatedClientsSuccess,
    (state, { data }): PaginatedClientState => ({
      ...state,
      ...data,
      ...data.pagination,
      total: Number(data.pagination?.total),
      loading: false,
    }),
  ),
  on(
    PaginatedClientActions.listPaginatedClientsFailure,
    (state, { error }): PaginatedClientState => ({
      ...state,
      error,
      loading: false,
    }),
  ),
  on(
    PaginatedClientActions.setRefGeopoint,
    (state, { refGeoPoint }): PaginatedClientState => ({
      ...state,
      refGeoPoint,
    }),
  ),
);

export const paginatedClientFeature = createFeature({
  name: paginatedClientFeatureKey,
  reducer,
});
